import i18n from 'i18n'

export const translateCodeList = (list, key) => {
  return list.map(({ code }) => ({
    code,
    name: i18n.t(`enum.${key}.${code}`)
  }))
}
